import EditArtistFormController from "./edit_artist_form_controller"

// Connects to data-controller="admin-artist-form"
//
// The Apple / Spotify pickers from the album artist modals, reused on the
// standalone admin artist page. The modal version is populated when it opens;
// here the page renders with the artist already known, so the same
// populateForm runs on connect.
export default class extends EditArtistFormController {
  static values = { artist: Object }

  connect() {
    super.connect()

    if (this.hasArtistValue && Object.keys(this.artistValue).length > 0) {
      this.populateForm(this.artistValue)
    }
  }
}
